import script from "./TopNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./TopNavbar.vue?vue&type=style&index=0&id=876f5e1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-876f5e1a"]])

export default __exports__